import type { TechniqueEntry } from '../schema';

export const framingOffer: TechniqueEntry = {
  key: 'framing_offer',
  version: '0.1',
  name: 'Framing offer',
  pillar: 'MI',
  serves:
    'Unsticking a member who says they do not know or stalls (treated as stuck, not resistant) by giving them one concrete framing to react to instead of another broad question.',
  method: [
    "Offer one framing or starting point, pitched tentatively so it is reactable: named as something other people in their situation find, never as a read on this member, composed from this member's context rather than stock, and ending by asking whether any of it lands.",
    'A correction of a wrong framing is as useful as agreement with a right one: the member corrects toward their truth. Offer it once.',
    "If the framing also gets a short or flat reply (an I-guess, a bare yeah, a not-really, another I-don't-know), the member is winding down, not stuck: stop offering framings and route to compress-and-close.",
  ],
  never: [
    "Never stack a second framing on a member who didn't take the first.",
    "Never answer an I-don't-know with another broad question.",
    'Never present the framing as a diagnosis or a fact about them.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause:
        'A genuine "I don\'t know" or stall after an open question, not disengagement (two or more short replies is already compress-and-close territory).',
    },
  ],
  doneWhen:
    'The member takes the framing somewhere of their own (extends it, corrects it, or uses it to name what is actually going on) or the flat reply routes the conversation to a gentle close.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'shared/sections/practice_constraints.md ("I don\'t know" path), agents/cab/sona/prompt.md, agents/intake/sona-v2/prompt.md (handling "I don\'t know")',
};
